import React from 'react';
import { motion } from 'framer-motion';
const variations = [{
  title: 'Primary Logomark',
  type: 'light'
}, {
  title: 'Monochrome Black',
  type: 'dark'
}, {
  title: 'Reversed White',
  type: 'color'
}, {
  title: 'Business Card',
  type: 'mockup-card'
}, {
  title: 'Signage System',
  type: 'mockup-sign'
}, {
  title: 'App Icon',
  type: 'mockup-app'
}, {
  title: 'Social Avatar',
  type: 'light'
}, {
  title: 'Letterhead',
  type: 'mockup-paper'
}];
export function LogoVariations() {
  return <section className="py-24 px-6 md:px-12 border-b-2 border-navy bg-white" id="work" data-id="element-156">
      <div className="max-w-7xl mx-auto" data-id="element-157">
        <div className="flex items-baseline justify-between mb-16 border-b-2 border-navy pb-4" data-id="element-158">
          <h2 className="text-4xl md:text-6xl font-bold text-navy tracking-tight" data-id="element-159">
            LOGO SYSTEM
          </h2>
          <span className="font-mono text-sm text-coral" data-id="element-160">
            01 / VISUAL IDENTITY
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[2px] bg-navy border-2 border-navy" data-id="element-161">
          {variations.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`aspect-square relative group overflow-hidden ${item.type === 'dark' ? 'bg-white' : item.type === 'color' ? 'bg-navy' : 'bg-gray-50'}`} data-id="element-162">
              <div className="absolute top-4 left-4 font-mono text-xs uppercase tracking-wider z-10 opacity-50" data-id="element-163">
                {item.title}
              </div>

              <div className="absolute inset-0 flex items-center justify-center p-8" data-id="element-164">
                {/* Abstract Geometric Logo Placeholder */}
                <div className={`w-24 h-24 relative transition-transform duration-500 group-hover:scale-110 group-hover:rotate-90`} data-id="element-165">
                  <div className={`absolute inset-0 border-[12px] ${item.type === 'color' ? 'border-white' : 'border-navy'}`} data-id="element-166" />
                  <div className={`absolute top-0 right-0 w-12 h-12 ${item.type === 'color' ? 'bg-coral' : 'bg-coral'}`} data-id="element-167" />
                  <div className={`absolute bottom-0 left-0 w-12 h-12 rounded-full ${item.type === 'color' ? 'bg-white' : 'bg-navy'}`} data-id="element-168" />
                </div>
              </div>

              {/* Grid Lines Overlay */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-169">
                <div className="absolute top-1/2 left-0 w-full h-[1px] bg-coral/30" data-id="element-170" />
                <div className="absolute left-1/2 top-0 h-full w-[1px] bg-coral/30" data-id="element-171" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}